import 'leaflet/dist/leaflet.css';

import { Box, Button, Checkbox, Divider, Grid, Link, Typography } from '@mui/material'
import React, { useState } from 'react'

import NeshanMap from 'react-neshan-map-leaflet'
import { submitCommentsOfNew } from '../../feature/api/news'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

// import NeshanMap from 'react-neshan-map-leaflet'



const Contact = () => {
    const dispatch = useDispatch()
    const {id} = useParams()
    const [bot,setBot] = useState(false)
    const [name,setName] = useState() 
    const [mobile,setMobile] = useState()
    const [comment,setComment] = useState()
    const handleForm = (e) =>{
        e.preventDefault()
        if(bot){
            if(name && mobile && comment ){
                dispatch(submitCommentsOfNew({
                    text:comment,
                    id:id,
                    name:name,
                    phone : mobile
                }))
                setName("")
                setMobile("")
                setComment("")
                setBot(false)
            }

        }else{
            toast.error('لطفا گزینه من ربات نیستم را فعال نمایید ')
        }
    }
    
  return (
    <Grid container  display={"flex"} justifyContent={"space-between"}  width={"100%"} bgcolor={"#000"}  p="20px 10px">
        <Grid item lg={6} xl={6} md={6} sm={12} xs={12}  display={"flex"} flexDirection={"column"} gap={6} p="10px">
            <Typography fontSize={"25px"} fontWeight={900} color="#EF7C00">از طریق فرم زیر با ما در تماس باشید</Typography>
            <Box component={"form"} onSubmit={handleForm}  display={"flex"} flexDirection={"column"} gap={6}>
                <input value={name} onChange={e => setName(e.target.value)} type="text" style={{padding:'10px',borderRadius:'20px',border:'none',outline:'none'}} placeholder='نام و نام خانوادگی' />
                {/* <input type="text" style={{padding:'10px',borderRadius:'20px',border:'none',outline:'none'}} placeholder='ایمیل' /> */}
                <input type="tel" value={mobile} onChange={e => setMobile(e.target.value)} style={{padding:'10px',borderRadius:'20px',border:'none',outline:'none'}} placeholder='تلفن تماس' />
                <textarea value={comment} onChange={(e) => setComment(e.target.value)} style={{padding:'10px',borderRadius:'20px',border:'none',outline:'none'}} name="description" cols="30" rows="10" placeholder='متن پیام' />
                <Box display={"flex"} width={"100%"} gap={1}>
                    <Grid item lg={6} xl={6} md={6} sm={12} xs={12}>
                        <Box border="1px solid #EF7C00" p="5px 10px" display={"flex"} justifyContent={"space-between"}>
                            <Box display={"flex"} gap={1} alignItems={"center"}>
                                <Checkbox value={bot} onChange={(e)=>setBot(!bot)} sx={{ border:'1px solid #EF7C00',borderRadius:0,p:0}}  />
                                <Typography color="#fff">من ربات نیستم</Typography>
                            </Box>
                            
                        </Box>

                    </Grid>
                    <Grid item lg={6} xl={6} md={6} sm={12} xs={12}>
                        <Button type='submit' fullWidth variant='contained' sx={{p:'7px 20px',bgcolor:'#EF7C00'}}>ارسال</Button>
                    </Grid>
                </Box>
            </Box>
        </Grid>
        <Grid item lg={5} xl={5} md={6} sm={12} xs={12}  display={"flex"} flexDirection={"column"}  gap={2} p="10px 30px">
            <Typography fontSize={"25px"} fontWeight={900} color="#EF7C00">اطلاعات تماس</Typography>
            <Divider sx={{bgcolor:'#fff'}} />
            <Box display={"flex"}  gap={5} >
                <img src="/images/gpsCall.png" alt="" width={"20px"} height={"25px"} />
                <Box display={"flex"} flexDirection={"column"}>
                    <Typography fontSize={"20px"} fontWeight={900} color="#EF7C00"> دفتر مرکزی</Typography>
                    <Typography color="#fff" >اصفهان، خیابان باغ گلدسته، </Typography>
                        <Typography color="#fff" >خیابان آیت الله خراسانی، مجتمع جان اسنک </Typography>
                </Box>

            </Box>
            <Divider sx={{bgcolor:'#fff'}} />
            
            <Box display={"flex"} gap={5} >
                <img src="/images/gpsCall.png" alt="" width={"20px"} height={"25px"} />
                <Box display={"flex"} flexDirection={"column"}>
                    <Typography fontSize={"20px"} fontWeight={900} color="#EF7C00"> شعب جان اسنک </Typography>
                    <Typography color="#fff" component={"p"} onClick={() =>window.location.href="https://superapp.jansnak.com/nearBranch"}> مشاهده روی نقشه  </Typography>

                </Box>

            </Box>
           
            <Divider sx={{bgcolor:'#fff'}}  />
              
            <Box display={"flex"}gap={5} >
                <img src="/images/phoneCall.png" alt="" width={"20px"} height={"25px"} />
                <Box display={"flex"} flexDirection={"column"}>
                    <Typography fontSize={"20px"} fontWeight={900} color="#EF7C00">   شماره تماس سراسری </Typography>
                    <Typography component={"a"} href="tel:1507" sx={{textDecoration:"none"}} color="#fff"> 1507 </Typography>

                </Box>

            </Box>
           
            <Divider sx={{bgcolor:'#fff'}} />
            <Box display={"flex"}gap={5} >
                <img src="/images/mailCall.png" alt="" width={"25px"} height={"19px"} />
                <Box display={"flex"} flexDirection={"column"}>
                    <Typography fontSize={"20px"} fontWeight={900} color="#EF7C00">   ایمیل</Typography>
                    <Typography color="#fff"> info@jansnak.com - crm@jansnak.com </Typography>
                </Box>

            </Box>
        
            <Divider sx={{bgcolor:'#fff'}} />


            <Box display={"flex"} flexDirection={"column"} alignItems={"center"} height={'100%'}  gap={3}> 
              

                    <NeshanMap
                    style={{width:"100%", height:'100px' }}
                    options={{
                        key: 'web.xTsQNqQ9zHqcqpyFLE2jnvnSWxt94atWbvB50RMY',
                        maptype: 'dreamy',
                        poi: true,
                        traffic: false,
                        center: [Number(32.6514999),Number(51.6757409)], 
                        zoom: 16,
                        gestureHandling: true
                    }}
                    onInit={(L, myMap) => {
                    
                        L.marker([Number(32.6514999),Number(51.6757409)],{autoPan:true})
                        .addTo(myMap)
                    
                    }}
                    
            /> 
         
            {/* // <img src="/images/map11.png" width={"100%"} alt="map" style={{borderRadius:'15px'}} /> */}

                    <Box display={"flex"}   data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="5000" justifyContent={"center"} position={"relative"} gap={1} width={"100px"}  alignItems={"center"} mr="7%">
                        <Link   border="1px solid #000" borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://www.aparat.com/jan_snak" >
                        <img src="/images/aparat.png" alt="" width="21px" height={"21px"} />
                        </Link>
                        <Link   border="1px solid #000" borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://t.me/jansnakbot" >
                        <img src="/images/telegram.png" alt="" width="21px" height={"21px"} />
                        </Link>
                        <Link   border="1px solid #000" borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://instagram.com/jan_snak" >
                        <img src="/images/facebook.png" alt="" width="21px" height={"21px"} />
                        </Link>
                        <Link  border="1px solid #000" borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://instagram.com/jan_snak" >
                        <img src="/images/instagram.png" alt=""width="21px" height={"21px"} />
                        </Link>
                                {/* <Box   mr="60%" border="1px solid #000" borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"}> */}
                        <Link    border="1px solid #000" borderRadius={"50%"} bgcolor={"#000"} height={'30px'}  width={"30px"} display={"flex"} alignItems={"center"} justifyContent={"center"} target='_blank' href="https://www.linkedin.com/company/jansnak">
                        <img src="/images/linkedin.png" alt="" width="21px" height={"21px"}/>
                        </Link>

                    </Box>

            </Box>
           
        </Grid>
    </Grid>
  )
}

export default Contact